import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { business, ctaImages } from '../mock';
import BotanicalDecor from './BotanicalDecor';

export default function CtaSection({ onSchedule }) {
  return (
    <section id="contact" className="section">
      <div className="container-x">
        <div
          className="rounded-[36px] overflow-hidden relative"
          style={{ backgroundColor: 'var(--forest)' }}
        >
          <div className="grid lg:grid-cols-2 gap-0 items-center">
            <div className="p-10 lg:p-16">
              <p className="eyebrow mb-2" style={{ color: '#B8D89E' }}>Peace of Mind</p>
              <h2 className="text-white" style={{ color: '#fff', fontSize: 'clamp(2rem, 3.6vw, 3rem)' }}>
                Experience peace of mind today
              </h2>
              <p className="mt-5 text-white/80">
                It only takes one call to deliver the reassurance you&rsquo;ve been longing for.
                Schedule your free, no-obligation in-home assessment and we&rsquo;ll craft a care
                plan built around your loved one.
              </p>
              <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4 mt-9">
                <button className="btn-sage justify-center w-full sm:w-auto" onClick={onSchedule}>
                  Schedule a Consultation <ArrowRight size={18} />
                </button>
                <a href={business.phoneHref} className="btn-ghost-light justify-center w-full sm:w-auto" style={{ border: '1.5px solid rgba(255,255,255,0.4)' }}>
                  <Phone size={18} /> {business.phone}
                </a>
              </div>
              <p className="text-white/50 text-sm mt-6">
                This website is not an emergency service. In an emergency, call 911.
              </p>
            </div>

            <div className="relative h-full min-h-[320px] p-6 lg:p-10">
              <BotanicalDecor style={{ top: 10, right: 10, width: 130, height: 300 }} color="rgba(255,255,255,0.28)" />
              <div className="grid grid-cols-2 gap-4 h-full relative" style={{ zIndex: 1 }}>
                <div className="rounded-3xl overflow-hidden float-anim" style={{ aspectRatio: '3/4' }}>
                  <img src={ctaImages[0]} alt="Caregiver and senior smiling together" className="w-full h-full object-cover" />
                </div>
                <div className="flex flex-col gap-4 mt-8">
                  <div className="rounded-3xl overflow-hidden float-anim" style={{ aspectRatio: '1/1', animationDelay: '0.8s' }}>
                    <img src={ctaImages[1]} alt="Happy senior at home" className="w-full h-full object-cover" />
                  </div>
                  <div className="rounded-3xl overflow-hidden float-anim" style={{ aspectRatio: '1/1', animationDelay: '1.6s' }}>
                    <img src={ctaImages[2]} alt="Caregiver providing companionship" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
